import { nanoid } from 'nanoid';
import { useMemo } from 'react';

export function useDataElTagGenerator(component: { name: string }) {
	const id = useMemo(() => nanoid(4), []);
	return (el = 'root') => ({ 'data-el': `${component.name}-${el}-${id}` });
}
